module.exports = __webpack_public_path__ + "img/IMG-20191124-WA0021.215d5986.jpg";